import React, { Component } from "react";
import PropTypes from "prop-types";
import { noop, isEqual } from "lodash";
import { SearchSelect } from "../base";
import language from "../../languages";
import background from "../../assets/img/background-merge.png";

class HeaderComponent extends Component {
  constructor(props) {
    super(props);

    this.onClickUnit = this.onClickUnit.bind(this);
    this.startEventSource = this.startEventSource.bind(this);
    this.onClickHeaderIcon = this.onClickHeaderIcon.bind(this);
    this.getNotifications = this.getNotifications.bind(this);
    this.readNotification = this.readNotification.bind(this);
    this.unitSelectorGroup = [
      "Bendahara",
      "Personalia",
      "Personalia SK",
      "Korektor Perwakilan",
      "Korektor Pusat",
      "Manager Keuangan",
    ];
    this.state = {
      notifications: [],
      iconState: {},
      selectedNotification: null,
      notificationState: {
        notifications: false,
      },
    };
    this.streamInterval = null;
  }

  componentDidMount() {
    this.getNotifications();
    // this.startEventSource();
  }

  // componentDidUpdate(prevProps, prevState) {
  //   if(
  //     !isEqual(prevState.notifications, this.state.notifications) ||
  //     !isEqual(prevState.iconState, this.state.iconState)) {
  //     this.setState(prevState => ({
  //       ...prevState,
  //       iconState: {
  //         ...prevState.iconState,
  //         notifications: true,
  //       }
  //     }));
  //   }
  //
  // }

  shouldComponentUpdate(nextProps = {}, nextState = {}) {
    const {
      notifications,
      iconState,
      notificationState,
      selectedNotification,
    } = this.state;

    const { user } = this.props;

    if (
      !isEqual(nextState.notifications, notifications) ||
      !isEqual(nextState.iconState, iconState) ||
      !isEqual(nextState.notificationState, notificationState) ||
      !isEqual(nextState.selectedNotification, selectedNotification) ||
      !isEqual(nextProps.user.workingUnit, user.workingUnit)
    ) {
      return true;
    }

    return false;
  }

  componentWillUnmount() {
    clearInterval(this.streamInterval);
  }

  onClickUnit(event) {
    const { setWorkingUnit } = this.props;
    const { target } = event;

    setWorkingUnit(target.value);
  }

  async onClickHeaderIcon(context) {
    if (context === "notifications") {
      const unreadNotifications = this.state.notifications.filter(
        (item) => !item.is_read,
      );

      for (const notification of unreadNotifications) {
        await this.readNotification(notification);
      }
    }

    this.setState((prevState) => ({
      iconState: {
        ...prevState.iconState,
        [context]: !prevState.iconState[context],
      },

      notificationState: {
        ...prevState.notificationState,
        [context]: !prevState.notificationState[context],
      },
    }));
  }

  async readNotification(notification) {
    const { handleReadNotification, user } = this.props;

    if (!notification.id || notification.is_read) {
      return;
    }

    try {
      await handleReadNotification({
        id: notification.id,
        user_id: user.id,
      });

      this.setState((prevState) => ({
        notifications: prevState.notifications.map((item) =>
          item.id === notification.id
            ? {
                ...item,
                is_read: true,
              }
            : item,
        ),
      }));
    } catch (error) {
      console.error("Gagal membaca notification:", error);
    }
  }
  async getNotifications() {
    const { handleGetNotifications, user } = this.props;

    if (!user) return;

    let units_code = "";

    if (user.workingUnit && user.workingUnit.attributes) {
      units_code = user.workingUnit.attributes.unit_code;
    } else if (user.school_unit && user.school_unit.unit_code) {
      units_code = user.school_unit.unit_code;
    }

    const payload = {
      units_code,
      user_id: user.id,
    };

    const data = await handleGetNotifications(payload);

    console.log(data);
    this.setState({
      notifications: data.notifications || [],
    });
  }

  startEventSource() {
    this.streamInterval = setInterval(() => {
      this.getNotifications();
    }, 10000);
  }

  render() {
    const { user, onSearchUnit } = this.props;
    const { school_unit, user_group, workingUnit, organization = {} } = user;
    const { logo_left = "", background_web = "" } = organization;
    let unitCode = "";
    let canSelectUnit = false;
    let defaultValue = {
      id: "0",
      title: "Semua Unit",
    };

    if (workingUnit && workingUnit.attributes) {
      unitCode = workingUnit.attributes.unit_code;
      defaultValue = {
        id: workingUnit.attributes.id,
        title: workingUnit.attributes.name,
      };
    } else if (school_unit && school_unit.unit_code) {
      unitCode = school_unit.unit_code;
      defaultValue = {
        id: school_unit.id,
        title: school_unit.name,
      };
    }
    if (
      user_group.name === "Manager Keuangan" ||
      user_group.name === "Bendahara" ||
      user_group.name === "Korektor Pusat" ||
      user_group.name === "Korektor Perwakilan" ||
      user_group.name === "Ketua Perwakilan" ||
      user_group.name === "Admin Keuangan" ||
      user_group.name === "Personalia" ||
      user_group.name === "Personalia SK"
    ) {
      canSelectUnit = true;
    }

    return (
      <header
        className="header"
        style={{ backgroundImage: `url(${background_web || background})` }}
      >
        <div className="header__top">
          <div className="header__top-left">
            <img className="header__logo" src={logo_left} alt="logo" />
            <div className="header__title">
              <p>KODE UNIT:</p>
              <p>{unitCode}</p>
            </div>
          </div>
          {user_group.id == 6 ? (
            <div className="header__icon notification-wrapper">
              <div className="notification-bell">
                <span
                  className="icon-bell"
                  onClick={() => this.onClickHeaderIcon("notifications")}
                />

                {this.state.notifications.reduce((total, item) => {
                  if (item.is_read) {
                    return total;
                  }

                  if (item.type === "schedule_without_teacher") {
                    return total + (Number(item.count) || 0);
                  }

                  return total + 1;
                }, 0) > 0 && (
                  <span className="notification-badge">
                    {this.state.notifications.reduce((total, item) => {
                      if (item.is_read) {
                        return total;
                      }

                      if (item.type === "schedule_without_teacher") {
                        return total + (Number(item.count) || 0);
                      }

                      return total + 1;
                    }, 0)}
                  </span>
                )}
              </div>

              {this.state.notificationState.notifications && (
                <div className="notification-dropdown">
                  {this.state.notifications.map((notification) => {
                    const isSelected =
                      this.state.selectedNotification === notification.id;

                    return (
                      <div
                        key={notification.id}
                        className="notification-item"
                        onClick={() => {
                          this.readNotification(notification);

                          this.setState({
                            selectedNotification: isSelected
                              ? null
                              : notification.id,
                          });
                        }}
                      >
                        {/* JUDUL */}
                        <div className="notification-title">
                          <span>{notification.title}</span>

                          <span className="notification-arrow">
                            {isSelected ? "▲" : "▼"}
                          </span>
                        </div>

                        {/* DETAIL - HANYA MUNCUL KALAU DIKLIK */}
                        {isSelected && (
                          <div className="notification-content">
                            <div className="notification-message">
                              {notification.message}
                            </div>
                            {notification.type ===
                              "schedule_without_teacher" && (
                              <div className="notification-details teacher-schedule-list">
                                {notification.details &&
                                notification.details.length > 0 ? (
                                  notification.details.map((detail, index) => (
                                    <div
                                      key={
                                        detail.schedule_subject_detail_id ||
                                        index
                                      }
                                      className="notification-detail-item"
                                    >
                                      <div>
                                        <strong>Kode Mapel:</strong>{" "}
                                        {detail.mapel_code || "-"}
                                      </div>

                                      <div>
                                        <strong>Hari:</strong>{" "}
                                        {detail.day_name || "-"}
                                      </div>

                                      <div>
                                        <strong>Jam:</strong>{" "}
                                        {detail.hour || "-"}
                                      </div>

                                      <div>
                                        <strong>Kelas:</strong>{" "}
                                        {detail.classrooms_name || "-"}
                                      </div>
                                    </div>
                                  ))
                                ) : (
                                  <div>Detail jadwal tidak tersedia.</div>
                                )}
                              </div>
                            )}

                            {notification.type === "teacher_without_code" && (
                              <div className="teacher-code-list">
                                {notification.details &&
                                  notification.details.map((detail) => (
                                    <div
                                      key={detail.nip}
                                      className="notification-detail"
                                    >
                                      {detail.nama_lengkap}
                                    </div>
                                  ))}
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          ) : (
            ""
          )}
          {/* <div className="header__top-right">
            <form className="header__search-form">
              <Input
                noMargin
                theme="line"
                leftIcon="icon-search"
                placeholder="Search here.."
                value=""
              />
            </form>

            <button
              className="header__icon"
              onClick={() => this.onClickHeaderIcon('download')}
            >
              <div className={`pulsar ${iconState.download ? '' : 'hidden'}`}>
                <div className="ring" />
              </div>
              <span className="icon-download" />
            </button>
            <button
              className="header__icon"
              onClick={() => this.onClickHeaderIcon('messaging')}
            >
              <div className={`pulsar ${iconState.messaging ? '' : 'hidden'}`}>
                <div className="ring" />
              </div>
              <span className="icon-comments" />
            </button>
            <button
              className="header__icon"
              onClick={() => this.onClickHeaderIcon('email')}
            >
              <div className={`pulsar ${iconState.email ? '' : 'hidden'}`}>
                <div className="ring" />
              </div>
              <span className="icon-envelope" />
            </button>
            <div
              className="header__icon"
            >
              <div className={`pulsar ${iconState.notifications ? '' : 'hidden'}`}>
                <div className="ring" />
              </div>
              <span className="icon-bell" onClick={() => this.onClickHeaderIcon('notifications')} />
              <Notifications
                data={notifications}
                history={history}
                visible={notificationState.notifications}
                handleAcceptReconciliation={handleAcceptReconciliation}
                updateNotificationStatus={updateNotificationStatus}
              />
            </div>
            <button
              className="header__icon"
              onClick={() => this.onClickHeaderIcon('refresh')}
            >
              <div className={`pulsar ${iconState.refresh ? '' : 'hidden'}`}>
                <div className="ring" />
              </div>
              <span className="icon-repeat" />
            </button>
            <button
              onClick={onClickMenu}
            >
              <img className="header__ypl-logo" src={yplLogo} alt="YPL Logo" />
            </button>
          </div> */}
        </div>
        <div className="header__bottom">
          <div className="header__top-left" />
          <div className="header__bottom-right">
            <p className="header__greeting">
              {language.translate.COMMON__WELCOME} {user.name}
            </p>
            {/* <Breadcrumb pathname={pathname} onClick={onClickBreadcrumb} /> */}
            {canSelectUnit && (
              <div className="unit_selector">
                <SearchSelect
                  async
                  onSearch={onSearchUnit}
                  onChange={this.onClickUnit}
                  labelName="title"
                  valueName="id"
                  placeholder="Pilih Unit Kerja"
                  value={user.workingUnit || defaultValue}
                />
              </div>
            )}
          </div>
        </div>
      </header>
    );
  }
}

export default function Header(props) {
  return <HeaderComponent {...props} />;
}

HeaderComponent.propTypes = {
  onSearchUnit: PropTypes.func,
  setWorkingUnit: PropTypes.func,
  user: PropTypes.object,
  handleGetNotifications: PropTypes.func,
  handleReadNotification: PropTypes.func,
};

HeaderComponent.defaultProps = {
  onSearchUnit: noop,
  setWorkingUnit: noop,
  user: null,
  handleGetNotifications: noop,
  handleReadNotification: noop,
};
